export const UserTab = {
  Info: "1",
  Costs: "2",
  Transaction: "3",
  Order: "4",
  Payment: "5",
  RefAffiliate: "6",
};
